// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2myD7","list":"PatternAutocomplete_list__3KueZ"};